import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("jwt");
  const isValid = !!token; // kasnije možeš JWT decode/expiry check
  return isValid ? children : <Navigate to="/login" replace />;
}

export default ProtectedRoute;